import * as yup from 'yup';
import { DictionaryType } from '../types/DictionaryType';

type SchemaObjectType = {
  fieldName: string;
  validationType?: ValidationTypeEnum;
  isRequired: boolean;
  fieldLength?: number;
  fieldType?: FieldTypeEnum;
  minValue?: number;
};

export enum ValidationTypeEnum {
  String = 'string',
  Number = 'number',
}

export type SchemaConfig = {
  name: string;
  validationType: string;
  validations: SchemaValidations[];
};

type SchemaValidations = {
  params: (string | number | RegExp)[];
  type: string;
};

enum FieldTypeEnum {
  Email = 'email',
  Date = 'date',
  Phone = 'telephoneNr',
  LocalDateTime = 'localDateTime',
}

const YupSchema = {
  create: (schema: any, config: SchemaConfig) => {
    // @ts-ignore
    if (!yup[config.validationType]) {
      return schema;
    }
    // @ts-ignore
    let validator = yup[config.validationType]();

    config.validations.forEach((validation) => {
      const { params, type } = validation;
      // @ts-ignore
      if (!validator[type]) {
        return;
      }
      // @ts-ignore
      validator = validator[type](...params);
    });

    schema[config.name] = validator;

    return schema;
  },
  getObject: (data: SchemaObjectType[]) => {
    const formData: DictionaryType<any>[] = [];

    for (let i = 0; i < data.length; i++) {
      const setting = data[i];
      const result: DictionaryType<any> = {
        name: setting.fieldName,
        validationType: setting.validationType || 'string',
        validations: [],
      };

      if (setting.isRequired) {
        result.validations.push({
          type: 'required',
          params: ['Required'],
        });
      }

      if (setting.minValue) {
        result.validations.push({
          type: 'required',
          params: ['Required'],
        });
      }

      if (setting.fieldLength) {
        result.validations.push({
          type: 'max',
          params: [setting.fieldLength, `Max. ${setting.fieldLength} characters`],
        });
      }

      if (setting.fieldType === FieldTypeEnum.Phone) {
        result.validations.push({
          type: 'matches',
          params: [/^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s./0-9]*$/, 'Invalid phone number format'],
        });
        result.validations.push({
          type: 'min',
          params: [8, `Too short. Minimum 8 digits.`],
        });
      }

      if (setting.fieldType === FieldTypeEnum.Email) {
        result.validations.push({
          type: 'email',
          params: ['Wrong value'],
        });
      }

      if (setting.fieldType === FieldTypeEnum.LocalDateTime) {
        result.validations.push({
          type: 'date',
          params: ['Wrong value'],
        });
      }

      formData.push(result);
    }

    return formData;
  },
};

export default YupSchema;
